import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import FadeIn from "../components/ui/FadeIn";
import TiltCard from "../components/ui/TiltCard";
import RainbowDivider from "../components/ui/RainbowDivider";

const PURPLE = "#8B6BE8";
const PURPLE_DEEP = "#5c3fb5";

const HomeschoolCompanion = () => (
  <div style={{ paddingTop: 72 }}>
    {/* ── Hero ── */}
    <section style={{ background:`linear-gradient(160deg,${PURPLE} 0%,${PURPLE_DEEP} 100%)`, padding:"100px 6vw 90px", position:"relative", overflow:"hidden", minHeight:"50vh", display:"flex", alignItems:"center" }}>
      <div style={{ position:"absolute", top:-80, right:-80, width:450, height:450, borderRadius:"50%", background:"rgba(255,255,255,0.07)", pointerEvents:"none" }}/>
      <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:2 }}>
        <Link to="/programs" style={{ display:"inline-flex", alignItems:"center", gap:6, fontFamily:"Nunito", fontWeight:700, fontSize:12.5, color:"rgba(255,255,255,0.75)", textDecoration:"none", marginBottom:16 }}>
          ← Back to All Programmes
        </Link>
        <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.15)", color:C.white, fontFamily:"Nunito", fontWeight:700, fontSize:11, letterSpacing:"0.15em", padding:"6px 16px", borderRadius:100, textTransform:"uppercase", marginBottom:20 }}>
          Homeschooling Support Programme
        </div>
        <h1 style={{ fontFamily:"Fredoka One", fontSize:"clamp(28px,5vw,58px)", color:C.white, lineHeight:1.1, margin:"0 0 20px", maxWidth:720 }}>
          A Homeschool Plan Built<br/><span style={{ color:C.yellow }}>Just for Your Child.</span>
        </h1>
        <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(15px,2vw,19px)", color:"rgba(255,255,255,0.85)", maxWidth:600, lineHeight:1.82, margin:"0 0 32px" }}>
          Every child is unique, and so should be their education. We take care of the planning, so you can focus on teaching, connecting, and nurturing your child with confidence.
        </p>
        <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
          <Link to="/admissions" style={{ background:C.yellow, color:C.navy, textDecoration:"none", fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"16px 32px", borderRadius:100, display:"inline-block" }}>Begin With an Assessment</Link>
          <a href="#weekly" style={{ background:"transparent", color:C.white, textDecoration:"none", fontFamily:"Nunito", fontWeight:700, fontSize:15, padding:"16px 32px", borderRadius:100, border:"2px solid rgba(255,255,255,0.4)", display:"inline-block" }}>See a Weekly Companion</a>
        </div>
      </div>
    </section>

    {/* ── Weekly companion preview ── */}
    <section id="weekly" style={{ background:C.cream, padding:"90px 6vw" }}>
      <div style={{ maxWidth:900, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:44 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:PURPLE, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Every Week</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,40px)", color:C.navy, margin:"0 0 14px" }}>Your Weekly Homeschool Companion</h2>
            <RainbowDivider />
          </div>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div style={{ background:C.white, borderRadius:24, padding:"32px 28px", boxShadow:"0 8px 30px rgba(0,0,0,0.06)" }}>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap", justifyContent:"center", marginBottom:24 }}>
              {["MON","TUE","WED","THU","FRI","SAT","SUN"].map(d => (
                <div key={d} style={{ fontFamily:"Nunito", fontWeight:800, fontSize:12, color:PURPLE, background:`${PURPLE}12`, border:`1.5px solid ${PURPLE}30`, borderRadius:10, padding:"8px 14px" }}>{d}</div>
              ))}
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:14 }}>
              {[
                "Daily lesson plan with clear objectives",
                "Parent script — what to teach, how, and what to ask",
                "Hands-on activity using things at home",
                "Observation sheet for the day",
              ].map(item => (
                <div key={item} style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
                  <div style={{ width:22, height:22, borderRadius:"50%", background:C.mint, color:C.white, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, flexShrink:0, marginTop:2 }}>✓</div>
                  <span style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.6 }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>

    {/* ── How it works ── */}
    <section style={{ background:C.warmGray, padding:"90px 6vw" }}>
      <div style={{ maxWidth:1000, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:PURPLE, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>How It Works</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,40px)", color:C.navy, margin:"0 0 14px" }}>One Assessment. Then It's Taken Care Of.</h2>
            <RainbowDivider />
            <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, maxWidth:560, margin:"0 auto", lineHeight:1.8 }}>
              There are only two moments you need to think about — telling us about your child, and opening your companion each week.
            </p>
          </div>
        </FadeIn>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:24 }}>
          {[
            { n:"1", title:"Initial child assessment — one time", items:["Current learning level","Strengths and areas requiring support","Interests and learning style","Academic and Islamic learning goals","Daily homeschooling routine"] },
            { n:"2", title:"Your companion — every week", items:["Delivered on schedule, four weeks a month","Adjusted based on your child's progress","Never a copy-paste template — always your child's plan"] },
          ].map(({ n, title, items }) => (
            <FadeIn key={n} delay={n * 0.1}>
              <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:22, padding:"30px 28px", boxShadow:"0 4px 16px rgba(0,0,0,0.05)", border:`2px solid ${PURPLE}18` }}>
                <div style={{ width:40, height:40, borderRadius:"50%", background:PURPLE, color:C.white, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Fredoka One", fontSize:17, marginBottom:16 }}>{n}</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:19, color:C.navy, marginBottom:16 }}>{title}</div>
                {items.map(it => (
                  <div key={it} style={{ display:"flex", gap:10, alignItems:"flex-start", marginBottom:10 }}>
                    <div style={{ width:6, height:6, borderRadius:"50%", background:PURPLE, marginTop:7, flexShrink:0 }}/>
                    <span style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.65 }}>{it}</span>
                  </div>
                ))}
              </TiltCard>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>

    {/* ── 7 pieces ── */}
    <section style={{ background:C.cream, padding:"90px 6vw" }}>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:PURPLE, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Every Week, in Your Companion</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,40px)", color:C.navy, margin:"0 0 14px" }}>You'll Always Know What to Teach, and How.</h2>
            <RainbowDivider />
            <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, maxWidth:600, margin:"0 auto", lineHeight:1.8 }}>
              Seven pieces, delivered weekly, so lesson planning is never something you have to sit down and figure out alone.
            </p>
          </div>
        </FadeIn>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:20 }}>
          {[
            { n:"1", title:"Weekly timetable",       body:"A personalized learning schedule built for your child's pace." },
            { n:"2", title:"Daily lesson plans",      body:"Clear objectives for every subject, every day." },
            { n:"3", title:"Parent teaching scripts", body:"What to teach, how to teach it, and suggested questions to ask." },
            { n:"4", title:"Hands-on activities",     body:"Simple, activity-based learning using materials already at home." },
            { n:"5", title:"Formative assessments",   body:"Weekly checklists so you can see progress as it happens." },
            { n:"6", title:"Observation sheets",      body:"Track learning and development in your own words." },
            { n:"7", title:"Curriculum adjustments",  body:"Next week's plan shaped by your child's progress." },
          ].map(({ n, title, body }, i) => (
            <FadeIn key={n} delay={i * 0.05}>
              <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:18, padding:"22px 22px", boxShadow:"0 3px 12px rgba(0,0,0,0.04)", border:`1.5px solid ${C.rainbow[i % C.rainbow.length]}25` }}>
                <div style={{ display:"flex", gap:12, alignItems:"flex-start" }}>
                  <div style={{ width:32, height:32, borderRadius:10, background:`${C.rainbow[i % C.rainbow.length]}20`, color:C.rainbow[i % C.rainbow.length], display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Fredoka One", fontSize:14, flexShrink:0 }}>{n}</div>
                  <div>
                    <div style={{ fontFamily:"Fredoka One", fontSize:15, color:C.navy, marginBottom:4 }}>{title}</div>
                    <p style={{ fontFamily:"Nunito", fontSize:12.5, color:C.muted, lineHeight:1.6, margin:0 }}>{body}</p>
                  </div>
                </div>
              </TiltCard>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>

    {/* ── Resource packs ── */}
    <section style={{ background:C.yellowBg, padding:"70px 6vw", borderTop:`4px solid ${C.yellow}40` }}>
      <div style={{ maxWidth:800, margin:"0 auto", textAlign:"center" }}>
        <FadeIn>
          <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.navy, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Optional Resource Packs</div>
          <p style={{ fontFamily:"Nunito", fontSize:14.5, color:C.muted, lineHeight:1.8, marginBottom:22 }}>
            Printable materials, purchased separately, for families who'd like extra support at home:
          </p>
          <div style={{ display:"flex", gap:10, flexWrap:"wrap", justifyContent:"center" }}>
            {["Worksheets","Flashcards","Matching cards","Busy books","Learning folders","Visual schedules","Educational games"].map(item => (
              <span key={item} style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12.5, color:C.navy, background:C.white, border:`1.5px solid ${C.yellow}60`, borderRadius:100, padding:"7px 16px" }}>{item}</span>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>

    {/* ── What's included / not ── */}
    <section style={{ background:C.navy, padding:"90px 6vw" }}>
      <div style={{ maxWidth:900, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:44 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.yellow, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Parent Support</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,38px)", color:C.white, margin:0 }}>What This Programme Is — and Isn't.</h2>
          </div>
        </FadeIn>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:22 }}>
          {[
            { icon:"✅", title:"Included", color:C.mint, items:["Curriculum-related questions by text, during working hours","A plan built and refined around your child specifically"] },
            { icon:"❌", title:"Not Included", color:C.coral, items:["Live classes or online teaching sessions","One-to-one coaching calls"] },
          ].map(({ icon, title, color, items }) => (
            <FadeIn key={title} delay={0.1}>
              <div style={{ background:"rgba(255,255,255,0.06)", border:`2px solid ${color}30`, borderRadius:20, padding:"28px 26px" }}>
                <div style={{ fontSize:28, marginBottom:10 }}>{icon}</div>
                <div style={{ fontFamily:"Fredoka One", fontSize:18, color, marginBottom:14 }}>{title}</div>
                {items.map(it => (
                  <div key={it} style={{ display:"flex", gap:10, alignItems:"flex-start", marginBottom:10 }}>
                    <div style={{ width:6, height:6, borderRadius:"50%", background:color, marginTop:7, flexShrink:0 }}/>
                    <span style={{ fontFamily:"Nunito", fontSize:14, color:"rgba(255,255,255,0.8)", lineHeight:1.65 }}>{it}</span>
                  </div>
                ))}
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>

    {/* ── Policy ── */}
    <section style={{ background:C.warmGray, padding:"80px 6vw" }}>
      <div style={{ maxWidth:760, margin:"0 auto" }}>
        <FadeIn>
          <div style={{ textAlign:"center", marginBottom:40 }}>
            <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:PURPLE, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>Good to Know</div>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(22px,3.2vw,34px)", color:C.navy, margin:0 }}>Subscription Policy</h2>
          </div>
        </FadeIn>
        {[
          "Monthly payment is required in advance to confirm your subscription.",
          "Your personalized weekly plans will be prepared and delivered according to the agreed schedule.",
          "As every learning plan is individually created for your child, payments are non-refundable once planning has begun.",
          "If you're unable to homeschool during a week — travel, illness, holidays, or personal commitments — that week's planning cannot be postponed, repeated, replaced, or carried forward, since it was already prepared exclusively for your child.",
        ].map((text, i) => (
          <FadeIn key={i} delay={i * 0.06}>
            <div style={{ display:"flex", gap:16, alignItems:"flex-start", marginBottom:16, padding:"16px 20px", background:C.white, borderRadius:14, border:`1.5px solid ${PURPLE}20` }}>
              <div style={{ width:26, height:26, borderRadius:"50%", background:PURPLE, color:C.white, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"Fredoka One", fontSize:12, flexShrink:0 }}>{String(i+1).padStart(2,"0")}</div>
              <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.7, margin:0 }}>{text}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>

    {/* ── Mission ── */}
    <section style={{ background:C.cream, padding:"80px 6vw" }}>
      <div style={{ maxWidth:640, margin:"0 auto", textAlign:"center" }}>
        <FadeIn>
          <div style={{ fontSize:40, marginBottom:16 }}>🤲</div>
          <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:PURPLE, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Our Mission</div>
          <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(22px,3.2vw,34px)", color:C.navy, margin:"0 0 18px" }}>Less Planning. More Presence.</h2>
          <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, lineHeight:1.85, marginBottom:20 }}>
            We take care of the planning, so you can focus on what matters most — building a meaningful, joyful, and faith-centered learning journey with your child.
          </p>
          <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:14.5, color:PURPLE, lineHeight:1.8 }}>
            May Allah ﷻ bless our efforts, grant our children beneficial knowledge, righteous character, and a lifelong love for learning. Ameen.
          </p>
        </FadeIn>
      </div>
    </section>

    {/* ── CTA ── */}
    <section style={{ background:`linear-gradient(160deg,${PURPLE} 0%,${PURPLE_DEEP} 100%)`, padding:"80px 6vw" }}>
      <div style={{ maxWidth:640, margin:"0 auto", textAlign:"center" }}>
        <FadeIn>
          <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,38px)", color:C.white, margin:"0 0 14px" }}>Ready to Begin?</h2>
          <p style={{ fontFamily:"Nunito", fontSize:15, color:"rgba(255,255,255,0.75)", lineHeight:1.8, marginBottom:32 }}>
            Reach out and we'll walk you through the assessment — no pressure, just a conversation about your child.
          </p>
          <div style={{ display:"flex", gap:14, justifyContent:"center", flexWrap:"wrap" }}>
            <Link to="/admissions" style={{ background:C.yellow, color:C.navy, textDecoration:"none", fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"16px 36px", borderRadius:100, display:"inline-block" }}>Start the Assessment</Link>
            <a href="https://wa.me/923390002106" style={{ background:"#25D366", color:C.white, textDecoration:"none", fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"16px 36px", borderRadius:100, display:"inline-block" }}>💬 WhatsApp</a>
          </div>
        </FadeIn>
      </div>
    </section>
  </div>
);

export default HomeschoolCompanion;
